<template>
  <p class="tw-mb-4 tw-text-gray-700">
    <SvgIcon
      :name="icon"
      class="tw-ml-1 tw-mr-2 tw-w-5 tw-h-5"
      style="margin-top: -3px"
    />
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'TextWithIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
}
</script>
